module.exports = __webpack_public_path__ + "./fonts/Baskervville-Italic.ttf";